import { call, put } from "redux-saga/effects";
import { AdminUserResponse } from "reduxStore/dataTypes";
import { fetchAdminUsers } from "services/apiService";
import {
  adminUserFailure,
  adminUserRequest,
  adminUserSuccess,
} from "../reducers/adminUsersReducer";

function* adminUsersSaga(
  action: any
): Generator<any, void, AdminUserResponse | any> {
  try {
    const { payload } = action;

    yield put(adminUserRequest());
    const response = yield call(fetchAdminUsers, payload);
    yield put(adminUserSuccess(response.data));
  } catch (error: any) {
    if (error && error.response) {
      yield put(adminUserFailure(error.response));
    } else {
      yield put(adminUserFailure(error.message));
    }
  }
}

export default adminUsersSaga;
